window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.fancy-radio, .fancy-radio-with-bullets').forEach((radio) => {
		const choices = radio.querySelectorAll('.gchoice');

		choices.forEach((choice) => {
			const textInput = choice.querySelector('input[type="text"]');

			if (textInput) {
				textInput.removeAttribute('disabled');
				textInput.value = '';
				textInput.setAttribute('placeholder', 'Anders');
			}

			choice.addEventListener('click', () => {
				choice.querySelector('label')?.click();
				textInput?.focus();
			});

			textInput?.addEventListener('click', () => {
				choice.querySelector('label')?.click();
			});
		});
	});

	const forms = document.querySelectorAll('.gform_wrapper form');

	forms.forEach((form) => {
		const pageFooter = form.querySelector('.gform-page-footer');
		const isFirstStep = !!form.querySelector('.gf_step_first.gf_step_active');

		if (isFirstStep) {
			const idealBanner = document.createElement('div');
			idealBanner.textContent = 'Bij een eenmalige donatie betaal je eenvoudig en snel met iDeal';
			idealBanner.setAttribute('class', 'flex flex-wrap');
			const logo = document.createElement('img');
			logo.setAttribute('src', strl_vars.stylesheet_directory + '/assets/img/ideal-logo.png');

			idealBanner.prepend(logo);
			pageFooter.prepend(idealBanner);
		}
	});
});
